<template>
  <div>
    <div id="hres4ax-popup2" class="panel box-collapse border-color-skin">
      <div class="box-header with-border box-header-collapse collapsed tab-header" @click.prevent="showModal = true">
        <h3 class="box-title">
          <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES4AXC4']['270'] }}
        </h3>
      </div>
    </div>

    <transition name="modal">
      <div v-if="showModal" class="modal-mask" >
        <div class="modal-wrapper"  >
          <div class="modal-container popuphres4ax">

            <div class="modal-header">
              <slot name="header">
                <i class="fa fa-close close" @click.prevent="closeModal()" ></i>
                <h4 class="modal-title">{{ labels['STDPOSP1']['30'] }}</h4>
              </slot>
            </div>
            <div class="modal-body">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-3 control-label">{{ labels['STDPOSP1']['40'] }}</label>
                  <div class="col-md-6">
                    <div class="form-control readonly-field-color">{{ detail.desc_codcomp }}</div>
                  </div>
                </div>

                <div class="form-group margin-b-5">
                  <label class="col-md-3 control-label">{{ labels['STDPOSP1']['50'] }}</label>
                  <div class="col-md-6">
                    <div class="form-control readonly-field-color">{{ detail.desc_codlinef }}</div>
                  </div>
                </div>
              </form> 

              <br>

              <slot name="body">
                <div id="accordion2"> 
                  <popup2-tab1 :labels="labels"
                               :data="popup2.tab1"
                              />
                  <popup2-tab2 :labels="labels"
                               :data="popup2.tab2"
                               :popup2Tab2Table="popup2Tab2Table"
                              />
                  <popup2-tab3 :labels="labels"
                               :data="popup2.tab3"
                               :popup2Tab3Table="popup2Tab3Table"
                              />
                </div>
              </slot>
            </div>      
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import popup2Tab1 from 'components/hres4ax/popup2Tab1'
import popup2Tab2 from 'components/hres4ax/popup2Tab2'
import popup2Tab3 from 'components/hres4ax/popup2Tab3'
export default {
  name: 'hres4ax-popup2',
  props: [ 'labels', 'detail', 'popup2', 'popup2Tab2Table', 'popup2Tab3Table' ],
  components: {
    popup2Tab1,
    popup2Tab2,
    popup2Tab3
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal () {
      this.showModal = false
    }
  }
}
</script>

<style lang='scss'>
  .popuphres4ax {
    width: 100%;
    height: 80vh;
    .modal-header {
      .close {
        font-size: 12px;
      }
    }
    .modal-body {
      padding: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// popup2.vue?7bc9c5e2